import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { seodata } from "../components/seo-data"
import StoreHero from "../components/store-hero"
import Products from "../components/store-products"
import VideoLightbox from "../components/video-lightbox"



var image;
var content = {
  hero: {
    title: (
      <span>
       Hands-On Cyber Training <br/> with Project Ares

      </span>
    ),
    text:
      "Build skills to better manage, monitor, and assess risk & vulnerabilities. In the wake of advancing technology, security professionals have to prioritize securing products and securing services. It puts a lot on their plate. Between log reviews, risk analysis, and continual monitoring, professionals need training solutions that automate routine tasks while given them the freedom to practice skills in ‘breakable environments’ to gracefully balance dual security responsibilities. Whether you’re establishing security protocols, improving upon them, building up security processes, or cultivating a stronger security culture, having the proper security knowledge and skills is critical to every facet of your job as a technology security professional. Hands-on cyber training can alleviate concerns that come out of challenges with infrastructure security and product devops. Finding the right training that is more than just resumé building is key. By upskilling with Project Ares, our hands-on cyber training solution, product and company security is strengthened persistently and proactively. ",
  },

  calendly: {
    text: "Schedule an Information Call",
  },


  cta1:{
    title:"Strengthen your cyber security reputation",
    text:"Advice for cyber leaders to protect their profession with strategic cyber training options.",
    url:"https://marketing.circadence.com/acton/fs/blocks/showLandingPage/a/36273/p/p-00e0/t/page/fm/0",
    cta:"Download Now"
  },
  social:{
    social1:{
      image:"",
      title:"Chris M UNCW Cyber Security Operations Club",
      text:"I personally found Project Ares to be a great learning experience and thought the mission environment was seamless. ",
      url:"/teach"
    }
  },
 //URL NEEDS UPDATE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  resources:{
    resource1:{
      
      title:"",
      text:"Gamification for Cyber Professional Development Learn why gamified learning can support skills training and acquisition for today’s cyber security professionals.",
      url:"https://marketing.circadence.com/acton/attachment/36273/f-1ebf399b-baed-420b-a651-3156c6cf248c/1/-/-/-/-/Gamification%20Fact%20Sheet%20%28links%20to%20gamification%20blog%20post%29.pdf"
    },
    resource2:{
     
      title:"",
      text:"Cyber Ranges and How They Improve Security Training Learn about the benefits of cyber range training environments and how they’ve evolved to optimize training for professionals.",
      url:"https://www.google.com"
    },
    resource3:{
      
      title:"",
      text:"] How it’s Built: Project Ares Missions Hear from Project Ares mission designers who are real-life cyber operators themselves, on how they’ve built mission scenarios in the platform to help professionals built the best cyber skills possible.",
      url:"https://marketing.circadence.com/acton/media/36273/webinar-how-its-built-project-ares"
    }, 
  },
  simple:{
    simple1:{
      text:"Build Your Resume: As you build your skills, align them to the NIST/NICE’s Work Role Framework.",
    },
    simple2:{
      text:"Rank yourself: How will your scores and XP stack up to others? Friendly competition through gamified elements can motivate your training.",
    },
    simple3:{
      text:"Improve at work: Train in realistic networks against real-world inspired threats to be better cyber defender for your organization.",
    },
    simple4:{
      text:"Cyber is complex. Be prepared. Integrate skills and optimize strategic thinking abilities with multi-faceted cyber activities",
    },
    simple5:{
      text:"Train on your own schedule with browser-based training available anytime, from any location",
    },
  }
}
 
 
class StorePage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      trailerLightbox: false,
    }

    this.handleOpenTrailer = this.handleOpenTrailer.bind(this);
    this.handleCloseTrailer = this.handleCloseTrailer.bind(this);
  }



handleOpenTrailer(){
this.setState({
  trailerLightbox:true
})

}

handleCloseTrailer(){
  this.setState({
    trailerLightbox:false
  })
  
}

  render() {
    return (
      <Layout>
      <SEO title={seodata.store.title} description={seodata.store.description} keywords={seodata.store.keywords} />
          <StoreHero handleOpenTrailer={this.handleOpenTrailer}/>
     
<VideoLightbox visible={this.state.trailerLightbox} close={this.handleCloseTrailer} videoURL="https://www.youtube.com/embed/wGp8FJHzxm8"/>
<Products/>

      </Layout>
    )
  }
}

export default StorePage
